<template>
  <div class="container">
    <div class="description">
      <md-field md-clearable>
        <label>説明</label>
        <md-input v-model="_Description" required maxlength="50"></md-input>
      </md-field>
    </div>

    <div class="type">
      <div class="title">
        <gl-sub-text>タイプ</gl-sub-text>
      </div>

      <md-radio v-model="_type" value="idpos" v-if="canUseIdPos">
        ID-POS
        <gl-sub-text></gl-sub-text>
      </md-radio>
      <md-radio v-model="_type" value="pos" v-if="canUsePos">
        POS
        <gl-sub-text></gl-sub-text>
      </md-radio>
    </div>

    <div class="outputColumns">
      <div class="title">
        <gl-sub-text>出力項目</gl-sub-text>
      </div>
      <div class="content" v-if="selectableOutputColumns.length > 0">
        <md-checkbox
          v-for="e in selectableOutputColumns"
          :key="e.key"
          v-model="_outputColumns"
          :value="e.key"
        >
          {{ e.label }}
        </md-checkbox>
      </div>
    </div>

    <div class="optionalDownloads">
      <div class="title">
        <gl-sub-text>追加ダウンロード</gl-sub-text>
      </div>
      <md-checkbox
        v-model="_optionalDownloads"
        value="item"
        :disabled="invalidExport('item_code')"
        >商品マスタ
      </md-checkbox>
      <md-checkbox
        v-model="_optionalDownloads"
        value="store"
        :disabled="invalidExport('store_code')"
        >店舗マスタ
      </md-checkbox>
      <md-checkbox
        v-model="_optionalDownloads"
        value="customer"
        :disabled="invalidExport('customer_code') || type === 'pos'"
        >顧客属性マスタ
      </md-checkbox>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

/**
 * 店舗（任意複数）選択コンポーネント
 */
export default {
  components: {},
  mixins: [ErrorReport],
  props: {
    /**
     * 説明
     */
    description: {
      type: String,
    },
    availableDataTypes: {
      type: Array,
    },
    /**
     * 選択しているジャーナルタイプ
     */
    type: {
      type: String,
    },
    /**
     * 選択されている出力項目
     */
    outputColumns: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択している追加ダウンロード
     */
    optionalDownloads: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /**
       * 店舗グループマスタ
       */
      storeGroups: [],
      /**
       * 店舗ツリー描画用データ
       */
      treeEntries: [],
    }
  },
  watch: {
    outputColumns: {
      handler() {
        this.normalizeOptionalDownloads()
      },
    },
    type: {
      handler() {
        this.normalizeOutputColumns()
        this.normalizeOptionalDownloads()
      },
    },
  },
  computed: {
    _type: {
      get() {
        return this.type
      },
      set(newVal) {
        this.$emit('update:type', newVal)
      },
    },
    canUsePos() {
      if (this.availableDataTypes) {
        return this.availableDataTypes.includes('pos')
      } else {
        return false
      }
    },
    canUseIdPos() {
      if (this.availableDataTypes) {
        return this.availableDataTypes.includes('idpos')
      } else {
        return false
      }
    },
    selectableOutputColumns() {
      if (this.type === 'idpos') {
        return this.$store.state.queryMetadata.outputColumns.filter(
          f => f.idpos,
        )
      } else if (this.type === 'pos') {
        return this.$store.state.queryMetadata.outputColumns.filter(f => f.pos)
      } else {
        return []
      }
    },
    errors() {
      const errors = []

      if (!this.description) {
        errors.push('説明を入力してください')
      }
      if (
        this.selectableOutputColumns.length > 0 &&
        (!this.outputColumns || this.outputColumns.length === 0)
      ) {
        errors.push('出力項目を選択してください')
      }
      return errors
    },
    _Description: {
      get() {
        return this.description
      },
      set(newVal) {
        this.$emit('update:description', newVal)
      },
    },
    _outputColumns: {
      get() {
        return this.outputColumns
      },
      set(newVal) {
        this.$emit('update:outputColumns', newVal)
      },
    },
    _optionalDownloads: {
      get() {
        return this.optionalDownloads
      },
      set(newVal) {
        this.$emit('update:optionalDownloads', newVal)
      },
    },
  },
  methods: {
    invalidExport(column) {
      return !this.outputColumns.includes(column)
    },
    normalizeOptionalDownloads() {
      const normalized = this.optionalDownloads.filter(downloadType => {
        if (downloadType === 'item') {
          return !this.invalidExport('item_code')
        }
        if (downloadType === 'store') {
          return !this.invalidExport('store_code')
        }
        if (downloadType === 'customer') {
          return this.type !== 'pos' && !this.invalidExport('customer_code')
        }
        return true
      })

      if (normalized.length !== this.optionalDownloads.length) {
        this.$emit('update:optionalDownloads', normalized)
      }
    },
    normalizeOutputColumns() {
      const validColumns = this.selectableOutputColumns.map(col => col.key)
      const normalized = this.outputColumns.filter(col =>
        validColumns.includes(col),
      )

      if (normalized.length !== this.outputColumns.length) {
        this.$emit('update:outputColumns', normalized)
      }
    },
  },
  async mounted() {},
}
</script>
